export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php?u='
export const TWITTER_SHARE_URL = 'https://twitter.com/share?url='
export const LINE_SHARE_URL = 'https://social-plugins.line.me/lineit/share?url='
export const ARTICLE_SLUG_URL = '/article/'
